/**
 * @module learning_content.transformer
 */

/**
 * Transform a learning-content tag into a normalized entity.
 *
 * @example from server:
 * {
 *   __typename: 'Tag',
 *   id: 123,
 *   name: 'My Tag Name'
 * }
 */
const learningTagFrom = (tag = {}) => ({
  // @ts-expect-error TS(2339): Property 'id' does not exist on type '{}'.
  id: tag.id,
  // @ts-expect-error TS(2339): Property 'name' does not exist on type '{}'.
  name: tag.name || '',
});

const learningTagsFrom = (tags = []) => {
  return tags.map((tag) => learningTagFrom(tag));
};

export { learningTagFrom, learningTagsFrom };
